export default __webpack_public_path__ + "static/media/plane-seat4.4fa9a666.svg";